import { SubSectionHeader } from '@/pages/CompanyReport/components/Overview/components/SubSectionHeader';
import { Section } from '@/pages/CompanyReport/components/Overview/components/Section';
import { useTracking } from 'react-tracking';
import PlusSolid from '@simplywallst/ui-core/icons/PlusSolid';
import { getPath } from '@/router/utils';
import { ROUTE_PUBLIC_NARRATIVE_CREATE } from '@/constants/routes';
import { useLocation } from '@/hooks/useLocation';
import { Button } from '@simplywallst/ui-core/next';

type Props = {
  canonicalUrl: string;
};

export const CompanyNarratives = ({ canonicalUrl }: Props) => {
  const { Track } = useTracking();
  const { pathname } = useLocation();
  const companyId = '123'; // TODO
  return (
    <Track>
      <Section data-cy-id="company-narratives">
        <header className="grid grid-cols-[1fr_max-content] justify-between gap-x1">
          <SubSectionHeader data-cy-id="company-narratives-heading">
            My Fair Value
          </SubSectionHeader>
          <Button
            variant="secondary"
            size="medium"
            href={getPath({
              type: ROUTE_PUBLIC_NARRATIVE_CREATE,
              payload: {
                query: { company: companyId, returnPath: pathname },
              },
            })}
          >
            <PlusSolid /> Create Narrative
          </Button>
        </header>

        <div>{canonicalUrl}</div>
      </Section>
    </Track>
  );
};
